export const VIEW_ADD_MODAL_TABS = {
  CREATE_FROM_SCRATCH: {
    key: 'create-from-scratch',
    title: 'Create from Scratch',
  },
  CREATE_FROM_TEMPLATE: {
    key: 'create-from-template',
    title: 'Create from Template',
  },
};
